import React from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { TypographyStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='business-services-page-content'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <AssistiveText component='h2'>Questions and answers</AssistiveText>
      <Row align='center'>
        <Col medium={6}>
          <Typography
            component='h3'
            align='center'
            nextElement='typography'>
            As a business owner, you probably have lots of standing <WidowBlock>questions, like:</WidowBlock>
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col medium={8}>
          <BulletedList
            bulletedListData={[
              { bulletText: (<>How can I attract the best people to best grow the business&#63;</>) },
              { bulletText: (<>If I get hurt or die, what happens to my business&#63;</>) },
              { bulletText: (<>Do my suppliers and vendors feel confident that my business will offer continuous service&#63;</>) },
              { bulletText: (<>Can my business fund the retirement I envision&#63;</>) },
            ]}
          />
          <TypographyStyled nextElement='graphic'>
            With so much on your mind, it&#39;s nice to know that professional guidance is there for you. At Northwestern Mutual, we offer expert guidance through our advisors, who are in business for themselves as well. This expertise has earned us the designation of one of the &#34;World&#39;s Most Admired&#34; life insurance companies in 2021 by <strong><em>FORTUNE&#174; 500</em></strong>.
          </TypographyStyled>
          <Typography nextElement='typography'>
            Our advisors can advise you about whatever is most important to you and your business. We&#39;ll help develop a personalized financial plan with solutions designed to meet the unique needs of your business, including:
          </Typography>
          <BulletedList
            disableBottomPadding
            bulletedListData={[
              { bulletText: 'Minimizing risk by preparing for surprises.' },
              { bulletText: 'Safeguarding your business with coverage to help offset the loss of cash flow in case you become sick or hurt.' },
              { bulletText: 'Recruit and retain employees with competitive benefits programs.' },
              { bulletText: (<>Transition your business smoothly with a well&#45;designed business succession plan.</>) },
              { bulletText: 'Integrate all aspects of financial planning for your business as well as your personal life.' },
            ]}
          />
        </Col>
      </Row>
    </SectionContainer>
  );
};
